import { fujifilmXZoonLensDataSet } from "./zoom";
export const fujifilmXLensDataSet = [
    ...fujifilmXZoonLensDataSet,
    {
        id: "4547410206159",
        EANCode: "4547410206159",
        maker: "Fujifilm",
        name: "XF35mmF1.4 R",
        mount: "X",
        focalLength: [35],
        fStop: [1.4],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: false,
        filterDiameter: 52,
        weight: 187,
        urls: {
            kakaku: "https://kakaku.com/item/K0000336433/",
        },
        releaseDate: "2012-02-18",
    },
    {
        id: "4547410206142",
        EANCode: "4547410206142",
        maker: "Fujifilm",
        name: "XF18mmF2 R",
        mount: "X",
        focalLength: [18],
        fStop: [2],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: false,
        filterDiameter: 52,
        weight: 116,
        urls: {
            kakaku: "https://kakaku.com/item/K0000336432/",
        },
        releaseDate: "2012-02-18",
    },
    {
        id: "4547410302783",
        EANCode: "4547410302783",
        maker: "Fujifilm",
        name: "XF16mmF1.4 R WR",
        mount: "X",
        focalLength: [16],
        fStop: [1.4],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: true,
        filterDiameter: 67,
        weight: 375,
        urls: {
            kakaku: "https://kakaku.com/item/K0000770447/",
        },
        releaseDate: "2015-05-21",
    },
    {
        id: "4547410302776",
        EANCode: "4547410302776",
        maker: "Fujifilm",
        name: "XF90mmF2 R LM WR",
        mount: "X",
        focalLength: [90],
        fStop: [2],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: true,
        filterDiameter: 62,
        weight: 540,
        urls: {
            kakaku: "https://kakaku.com/item/K0001379950/",
        },
        releaseDate: "2015-07-16",
    },
    {
        id: "4547410310405",
        EANCode: "4547410310405",
        maker: "Fujifilm",
        name: "XF35mmF2 R WR",
        mount: "X",
        focalLength: [35],
        fStop: [2],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: true,
        filterDiameter: 43,
        weight: 170,
        urls: {
            kakaku: "https://kakaku.com/item/K0001379950/",
        },
        releaseDate: "2015-11-19",
    },
    {
        id: "4547410328813",
        EANCode: "4547410328813",
        maker: "Fujifilm",
        name: "XF23mmF2",
        mount: "X",
        focalLength: [23],
        fStop: [2],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: true,
        filterDiameter: 43,
        weight: 180,
        urls: {
            kakaku: "https://kakaku.com/item/K0000903386/",
        },
        releaseDate: "2016-10-06",
    },
    {
        id: "4547410435856",
        EANCode: "4547410435856",
        maker: "Fujifilm",
        name: "XF50mmF1.0 R WR",
        mount: "X",
        focalLength: [50],
        fStop: [1.0],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: true,
        filterDiameter: 77,
        weight: 845,
        urls: {
            kakaku: "https://kakaku.com/item/K0001286475/",
        },
        releaseDate: "2020-09-24",
    },
    {
        id: "4547410440386",
        EANCode: "4547410440386",
        maker: "Fujifilm",
        name: "XF27mmF2.8 R WR",
        mount: "X",
        focalLength: [27],
        fStop: [2.8],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: true,
        filterDiameter: 39,
        weight: 84,
        urls: {
            kakaku: "https://kakaku.com/item/K0001328213/",
        },
        releaseDate: "2021-03-11",
    },
    {
        id: "4547410442557",
        EANCode: "4547410442557",
        maker: "Fujifilm",
        name: "XF18mmF1.4 R LM WR",
        mount: "X",
        focalLength: [18],
        fStop: [1.4],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: true,
        filterDiameter: 62,
        weight: 370,
        urls: {
            kakaku: "https://kakaku.com/item/K0001348957/",
        },
        releaseDate: "2021-05-27",
    },
    {
        id: "4547410455465",
        EANCode: "4547410455465",
        maker: "Fujifilm",
        name: "XF33mm F1.4 R LM WR",
        mount: "X",
        focalLength: [33],
        fStop: [1.4],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: false,
        filterDiameter: 58,
        weight: 360,
        urls: {
            kakaku: "https://kakaku.com/item/K0001379950/",
        },
        releaseDate: "2021-09-29",
    },
    {
        id: "4547410471045",
        EANCode: "4547410471045",
        maker: "Fujifilm",
        name: "XF56mmF1.2 R WR",
        mount: "X",
        focalLength: [56],
        fStop: [1.2],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: false,
        filterDiameter: 67,
        weight: 445,
        urls: {
            kakaku: "https://kakaku.com/item/K0001471399/",
        },
        releaseDate: "2021-09-29",
    },
    {
        id: "4547410464344",
        EANCode: "4547410464344",
        maker: "Fujifilm",
        name: "XF23mmF1.4 R LM WR",
        mount: "X",
        focalLength: [23],
        fStop: [1.4],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: true,
        filterDiameter: 58,
        weight: 375,
        urls: {
            kakaku: "https://kakaku.com/item/K0001379949/",
        },
        releaseDate: "2022-02-24",
    },
    {
        id: "4547410493856",
        EANCode: "4547410493856",
        maker: "Fujifilm",
        name: "XF8mmF3.5 R WR",
        mount: "X",
        focalLength: [8],
        fStop: [3.5],
        format: "APS-C",
        focus: ["AF", "MF"],
        hasStabilizer: false,
        hasDustMoistureResistance: true,
        filterDiameter: 62,
        weight: 215,
        urls: {
            kakaku: "https://kakaku.com/item/K0001539680/",
        },
        releaseDate: "2023-06-29",
    },
];
